import React from 'react';
import { upperCase } from 'lodash';
import className from 'classnames';
import TableHeader from '../TableHeader';

const UserScoresList = ({
  userScores
}) => {

  const displayBreakdownValue = (breakdownValue) => {
    if (typeof breakdownValue === 'object') {
      return `${breakdownValue.score} (${breakdownValue.grade})`
    } else {
      return breakdownValue.toString()
    }
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h3 className='MainHeader__h3'>User Scores</h3>
        </div>
      </div>
      <div
        className={className('Table', {
          'Table--trust-parameters': true,
        })} style={{gridTemplateColumns: '1fr 1fr 1fr 4fr'}}
      >
        {(() => {
        const columnHeaders = [
          {
            label: 'User ID'
          },
          {
            label: 'Score',
            className: 'Table__col--ta-c'
          },
          {
            label: 'Grade',
            className: 'Table__col--ta-c'
          },
          {
            label: 'Breakdown'
          }
        ]

        return (
          <div className='Table__row'>
            {columnHeaders.map((header, key) => (
              <TableHeader
                key={key}
                header={header}
              />
            ))}
          </div>
          )
        })()}
        {
          userScores.length < 1 &&
            <div className='Table__row__no-records'>No records</div>
        }
        {userScores.map((userScore) => (
          <div
            className='Table__row'
            key={userScore.user_id}
          >
            <div className='Table__col'>
              <a
                className='DotTooltip__link'
                onClick={() => {
                  window.open(`/${gon.currentProvider}/users/${userScore.user_id}`)
                }}
              >{userScore.user_id}</a></div>
            <div className='Table__col Table__col--ta-r'>
              {(+userScore.data.score).toLocaleString()}
            </div>
            <div className='Table__col Table__col--ta-c'>{upperCase(userScore.data.grade)}</div>
            <div className='Table__col'>
              <table>
                <tbody>
                  {
                    Object.entries(userScore.data.breakdown).map(([key, value]) => {
                      return(
                        <tr key={`${userScore.user_id}${key}`}>
                          <td>{key}</td>
                          <td className='TrustScoreTable__col--number'>{displayBreakdownValue(value)}</td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

export default UserScoresList
